module.exports = __webpack_public_path__ + "img/sq4m_banner.a35f7db8.jpg";